<script setup lang="ts">
import { ref } from 'vue';
import { useCacheStore } from '../stores/cacheStore';
import { useNotificationStore } from '../stores/notificationStore';

const cacheStore = useCacheStore();
const notificationStore = useNotificationStore();
const processing = ref(false);

const clearCache = async () => {
  if (!confirm('¿Está seguro de que desea borrar el caché? La aplicación necesitará volver a cargar todos los datos.')) {
    return;
  }

  processing.value = true;
  try {
    cacheStore.clearCache();
    notificationStore.success('Caché borrado correctamente');
    // Recargar la página para forzar una nueva carga de datos
    window.location.reload();
  } catch (error) {
    notificationStore.error('Error al borrar el caché');
  } finally {
    processing.value = false;
  }
};
</script>

<template>
  <div class="bg-white p-6 rounded-lg shadow-sm border border-slate-200">
    <h3 class="text-lg font-semibold text-slate-800 mb-4">Gestión de Caché</h3>
    
    <div class="space-y-4">
      <p class="text-sm text-slate-600">
        La aplicación almacena datos en caché para mejorar el rendimiento. 
        Si experimenta problemas o necesita forzar una actualización de datos, 
        puede borrar el caché aquí.
      </p>

      <div v-if="cacheStore.isOutdated" class="bg-amber-50 text-amber-700 p-4 rounded-lg text-sm">
        Los datos en caché están desactualizados. Se recomienda borrar el caché 
        para obtener los datos más recientes.
      </div>

      <button 
        @click="clearCache"
        class="bg-red-100 text-red-700 hover:bg-red-200 px-4 py-2 rounded-lg transition-colors duration-200"
        :disabled="processing"
      >
        {{ processing ? 'Borrando caché...' : 'Borrar Caché' }}
      </button>
    </div>
  </div>
</template>